// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'registrationStatus',
                    value: 'REGISTRATION_STATUS'
                },
                {
                    key: 'registrationDate',
                    value: 'REGISTRATION_DATE'
                },
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'accountNumber',
                    value: 'ACCOUNT_NUMBER'
                },
                {
                    key: 'accountAddress',
                    value: 'ACCOUNT_ADDRESS'
                },
                {
                    key: 'statusIndicator',
                    value: 'STATUS_INDICATOR'
                },
                {
                    key: 'deliveryDate',
                    value: 'DELIVERY_DATE'
                },
                {
                    key: 'expectedDateOfFirstUse',
                    value: 'EXPECTED_DATE_OF_FIRST_USE'
                },
                {
                    key: 'comments',
                    value: 'COMMENTS'
                },
                {
                    key: 'customerNumber',
                    value: 'CUSTOMER_NUMBER'
                },
                {
                    key: 'customerName',
                    value: 'CUSTOMER_NAME'
                },
                {
                    key: 'street1',
                    value: 'STREET_1'
                },
                {
                    key: 'street2',
                    value: 'STREET_2'
                },
                {
                    key: 'postalCode',
                    value: 'POSTAL_CODE'
                },
                {
                    key: 'city',
                    value: 'CITY'
                },
                {
                    key: 'region',
                    value: 'REGION'
                },
                {
                    key: 'country',
                    value: 'COUNTRY'
                },
                {
                    key: 'message',
                    value: 'MESSAGE'
                },
                {
                    key: 'id',
                    value: 'REGISTRATION_FORM'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'registrationDate',
                    order: 'DESC',
                    value: 'Registration Date'
                }
            ]
        }
    ]);

export default Views;




// WEBPACK FOOTER //
// ./src/reports/registrations-review/state/views.js